import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const withValidationSpinner = (Comp)=>{
    return (_props)=>{
        const { children, validationSpinnerProps: { status }, ...props } = _props;
        return /*#__PURE__*/ _jsxs("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ _jsx("span", {
                    style: {
                        transform: "scale(0.7)"
                    },
                    className: "absolute right-2 top-1",
                    children: status
                }),
                /*#__PURE__*/ _jsx(Comp, {
                    ...props
                }),
                children
            ]
        });
    };
};
